import { combineReducers } from 'redux';
import packageOptions from './package';
import itemLocationZone from './item-location-zone';
import availabilityOptions from './availability';

export default combineReducers({
  package: packageOptions,
  itemLocationZone,
  availabilityOptions
});
